export default __webpack_public_path__ + "static/media/what-is-needed.a489b501.svg";